import { getEnvironmentVariableByName } from "./envs.utils";

function isSeonEnabled() {
  return (
    getEnvironmentVariableByName("ENABLE_SEON") === "true" &&
    typeof window.seon !== "undefined"
  );
}

function isSeonAvailable() {
  return (
    window?.seon &&
    typeof window?.seon?.init === "function" &&
    typeof window?.seon?.getSession === "function"
  );
}

export async function initAndGetSeonPayload() {
  if (!isSeonEnabled()) return;
  try {
    if (!isSeonAvailable())
      throw new Error(
        "SEON v6 script is not loaded. Please include the SEON v6 script in your HTML.",
      );
    const storedSessionId = sessionStorage.getItem("seon_session_id");
    if (storedSessionId) return storedSessionId;
    await window.seon.init();
    const sessionId = await window.seon.getSession();
    sessionStorage.setItem("seon_session_id", sessionId);
    return sessionId;
  } catch (error) {
    console.error("SEON initialization or session retrieval failed:", error);
    return undefined;
  }
}
